/* ==========================================================================
   Nootrópicos México v70.9.3 — Runtime compatibility guards
   ========================================================================== */
(function () {
  "use strict";

  /* modern-ui.js still registers two small modules through the historical
     ready(callback) helper. Keep that contract explicit and dependency-free. */
  if (typeof window.ready !== "function") {
    window.ready = function (callback) {
      if (typeof callback !== "function") return;
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
      } else {
        callback();
      }
    };
  }
})();
